import Modal from "react-modal";
import { Container, Contents, Title } from "./styled";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { useEffect, useState } from 'react'
import { saveAs } from "file-saver";
import { toast } from "react-toastify";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "540px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "transparent",
        padding: "0px",
        margin: "0px",
        borderRadius: "8px",
        border: "none"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    },
};



const ModalCadLicenses = (props) => {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.reducerLanguage);
    const { id } = useParams();
    const reducerAddLicenses = useSelector((state) => state.reducerAddLicenses);

    const [name, setName] = useState("")



    const closeModal = () => {
        //props.handleClick()

        setTimeout(() => {
            props.setVisible(false)
            props.goSearch()
            //props.setDataModalDeleteCompleted([])
        }, 0);
    }

    useEffect(() => {
   
    }, [])

    const save = () => {
        dispatch({ type: "SAGA_ADD_LICENSES", payload: { name: name } })
        //closeModal()
    }


    useEffect(() => {
        if (reducerAddLicenses.loading == false && reducerAddLicenses.error == false && reducerAddLicenses.data.length == 0) {
        } else {
            console.log("reducerAddLicenses", reducerAddLicenses)
            const id = "reducerAddLicenses"
            if (reducerAddLicenses.loading) {
                toast.loading("Aguarde..", { toastId: id })
            } else {
                if (reducerAddLicenses.error) toast.update(id, { render: "Erro ao cadastrar licença", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Licença cadastrada com sucesso", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    //props.goSearch()
                    //closeModal()
                    props.setVisible(false)
                    props.goSearch()
                    dispatch({ type: "LICENSES_ADD_RESET" })
                }
            }
        }
    }, [reducerAddLicenses])

    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { }}
        >
            <Container>
                <Title>
                    <div>
                        <label>Cadastro de licenças</label>
                        <XMarkIcon onClick={() => { closeModal() }} style={{ cursor: "pointer" }} width={20} />
                    </div>
                    <label >
                        Após a criação da licença adicione os codigos.
                    </label>
                </Title>
                <Contents>
                    <div>
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            Nome
                        </label>
                        <div className="mt-2">
                            <input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                id="name"
                                name="email"
                                type="text"
                                placeholder="Card R$ 20,00"
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#111827] sm:text-sm/6"
                            />
                        </div>
                    </div>
                    <div className="flex shrink-0 justify-end px-4 py-4">
                        <button
                            type="button"
                            onClick={() => { closeModal() }}
                            className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={() => save()}
                            type="submit"
                            className="ml-4 inline-flex justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-500"
                        >
                            Salvar
                        </button>
                    </div>
                </Contents>
            </Container>

        </Modal >
    )
}

export default ModalCadLicenses

